module.exports = obj => Object.prototype.toString.call(obj) === '[object Array]'


// WEBPACK FOOTER //
// ./src/helpers/is_array.js